<template>
    <div>
        <email-onboarding-domain>
            <div class="flex-column">
                <div class="flex-row mb-2">
                    <span class="grey bold fs-5">{{ $l10n.__('Paramètres des emails /') }} </span>
                    <h2 class="m-0 ml-1 fs-5">{{ $l10n.__('Authentification du domaine') }}</h2>
                </div>
                <span class="link flex-level pb-1" @click="backToSettingEmail()"
                    ><i class="icon-chevron-left mr-1"></i>
                    {{ $l10n.__('Revenir aux paramètres des emails') }}</span
                >
            </div>
        </email-onboarding-domain>
    </div>
</template>

<script>
import EmailOnboardingDomain from 'vcomponents/email/EmailOnboardingDomain.vue';
import { FadeOutIn } from 'utils/transition';

export default {
    name: 'SettingsEmailDomain',
    methods: {
        /**
         * Temporary... as long as xsl is used before use vue router and SettingsEmailDomain component like a page
         * Make the component disappear and then the xsl appear
         */
        backToSettingEmail() {
            const prefsFormEl = document.getElementById('prefsForm');
            const settingsEmailDomainEl = document.getElementById('settingsEmailDomain');

            FadeOutIn(settingsEmailDomainEl, prefsFormEl);
        },
    },
    components: {
        EmailOnboardingDomain,
    },
};
</script>
